module.exports = __webpack_public_path__ + "assets/webgl/LM_2_2.d506f056.jpg";